(() => {
 if (window.ncSiteReady) return;
 window.ncSiteReady = true;
 const closeMenus = (except) => document.querySelectorAll('nc-site-header details[open]').forEach(menu => { if (menu !== except) menu.open = false; });
 document.addEventListener('click', event => {
  const link = event.target.closest('[data-nc-cart-open]');
  const drawer = document.getElementById('cart-drawer');
  if (link && typeof drawer?.open === 'function') { event.preventDefault(); closeMenus(); drawer.open(); }
  if (!event.target.closest('nc-site-header')) closeMenus();
  if (event.target.closest('.ncv-mobile-nav__panel a')) closeMenus();
  const summary = event.target.closest('nc-site-header summary');
  if (summary) closeMenus(summary.parentElement);
 });
 document.addEventListener('focusin', event => {
  closeMenus(event.target.closest('nc-site-header details'));
 });
 document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const openMenu = document.querySelector('nc-site-header details[open]');
  if (openMenu) { closeMenus(); openMenu.querySelector('summary')?.focus(); }
 });
 const updateCartCount = quantity => {
  document.querySelectorAll('[data-nc-cart-count]').forEach(el => {
   el.textContent = quantity;
   el.closest('.ncv-cart-link')?.setAttribute('aria-label', `Shopping bag, ${quantity} ${quantity === 1 ? 'item' : 'items'}`);
  });
 };
 let cartRequest;
 document.addEventListener('shopify:cart:lines-update', event => {
  Promise.resolve(event.promise).then(async ({detail} = {}) => {
   if (detail?.didError) return;
   if (Array.isArray(detail?.items)) {
    const quantity = detail.items.reduce((total,item) => total + Number(item.quantity || 0), 0);
    updateCartCount(quantity);
    return;
   }
   cartRequest?.abort(); cartRequest = new AbortController();
   const response = await fetch((window.Shopify?.routes?.root || '/')+'cart.js', {signal:cartRequest.signal});
   if (!response.ok) return;
   const cart = await response.json();
   updateCartCount(cart.item_count);
  }).catch(() => {});
 });
})();
